import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics].sort(
    (a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime(),
  );

  return (
    <section className="w-full bg-background-100/70" aria-label="最新更新">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">每日更新，精彩不停歇</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {latest.map((comic) => {
            const latestChapter = comic.chapters[comic.chapters.length - 1];
            return (
              <div
                key={comic.id}
                className="flex items-center gap-4 p-3 md:p-4 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-colors"
              >
                <Link to={`/comic/${comic.id}`} className="shrink-0 cursor-pointer">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden bg-background-200">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </Link>

                <div className="flex-1 min-w-0">
                  <Link
                    to={`/comic/${comic.id}`}
                    className="text-sm md:text-base font-medium text-foreground-800 hover:text-primary-500 transition-colors line-clamp-1"
                  >
                    {comic.title}
                  </Link>
                  <p className="text-xs text-foreground-400 mt-0.5">
                    {comic.author} · {comic.categories.map(c => {
                      const map: Record<string, string> = {
                        guoman: '国产', rexue: '热血', lianai: '恋爱', xuanhuan: '玄幻',
                        wuxia: '武侠', kehuan: '科幻', xuanyi: '悬疑', gaoxiao: '搞笑',
                        qihuan: '奇幻', dushi: '都市',
                      };
                      return map[c] || c;
                    }).join('·')}
                  </p>
                </div>

                <div className="text-right shrink-0">
                  <Link
                    to={`/comic/${comic.id}/chapter/${latestChapter?.id || '1'}`}
                    className="text-xs text-primary-500 hover:text-primary-600 transition-colors line-clamp-1 max-w-[120px] block"
                  >
                    {latestChapter?.title || '查看详情'}
                  </Link>
                  <p className="text-xs text-foreground-400 mt-0.5">{comic.updateTime}</p>
                </div>

                <Link
                  to={`/comic/${comic.id}/chapter/${latestChapter?.id || '1'}`}
                  className="hidden sm:inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  阅读
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}